import { createContext } from "react";

export const ColoresContext = createContext()
export const ColoresFormContext = createContext()
export const ColoresReportContext = createContext()